// extracted by mini-css-extract-plugin
module.exports = {"FrontBox":"FrontBox_FrontBox__OAL6Z"};